import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src692692924/src/doctor-dashboard/app/_providers/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginPage"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/common-pages/dist/esm/auth/LoginPage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PasswordRecoveryPage"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/common-pages/dist/esm/auth/PasswordRecoveryPage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PasswordUpdatePage"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/common-pages/dist/esm/auth/PasswordUpdatePage.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/common-pages/dist/esm/error/GenericErrorPage.js");
;
import(/* webpackMode: "eager", webpackExports: ["MaintenancePage"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/common-pages/dist/esm/error/MaintenancePage.js");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundPage"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/common-pages/dist/esm/error/NotFoundPage.js");
;
import(/* webpackMode: "eager", webpackExports: ["useChunkLoadErrorHandler"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/hooks/dist/esm/useChunkLoadErrorHandler.js");
;
import(/* webpackMode: "eager", webpackExports: ["useCleanPathname"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/hooks/dist/esm/useCleanPathname.js");
;
import(/* webpackMode: "eager", webpackExports: ["useLocale"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/hooks/dist/esm/useLocale.js");
;
import(/* webpackMode: "eager", webpackExports: ["useRouterPush"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/hooks/dist/esm/useRouterPush.js");
;
import(/* webpackMode: "eager", webpackExports: ["useRouterPushPromise"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/hooks/dist/esm/useRouterPushPromise.js");
;
import(/* webpackMode: "eager", webpackExports: ["useLangCookieSetter","useLocaleRedirect","useLocaleCookie","useLangCookieValue","useInitializeLocaleCookie"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/language-select/dist/esm/langSelect.hooks.js");
;
import(/* webpackMode: "eager", webpackExports: ["LangSelector","localeNameMap"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/language-select/dist/esm/LanguageSelect.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link","NextLinkComposed"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@ianesthesie-kit/link/dist/esm/Link.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/icons-material/Add.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/icons-material/KeyboardArrowDown.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/icons-material/Remove.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Accordion/Accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/AccordionActions/AccordionActions.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/AccordionDetails/AccordionDetails.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/AccordionSummary/AccordionSummary.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Alert/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/AlertTitle/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/AppBar/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Autocomplete/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Avatar/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/AvatarGroup/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Backdrop/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Badge/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/BottomNavigation/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/BottomNavigationAction/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Breadcrumbs/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ButtonBase/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ButtonGroup/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Card/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CardActionArea/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CardActions/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CardContent/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CardHeader/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CardMedia/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Checkbox/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Chip/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClickAwayListener"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ClickAwayListener/ClickAwayListener.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Collapse/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/CssBaseline/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Dialog/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/DialogActions/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/DialogContent/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/DialogContentText/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/DialogTitle/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Divider/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Drawer/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Fab/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Fade/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/FilledInput/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/FormControl/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/FormControlLabel/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/FormGroup/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/FormHelperText/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/FormLabel/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/GlobalStyles/GlobalStyles.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Grid/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Grow/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Hidden/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Icon/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/IconButton/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ImageList/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ImageListItem/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ImageListItemBar/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Input/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/InputAdornment/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/InputBase/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/InputLabel/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/LinearProgress/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Link/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/List/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListItem/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListItemAvatar/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListItemButton/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListItemIcon/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListItemSecondaryAction/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListItemText/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ListSubheader/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Menu/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/MenuItem/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/MenuList/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/MobileStepper/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Modal/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/NativeSelect/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/NoSsr/NoSsr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/OutlinedInput/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Pagination/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/PaginationItem/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Paper/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Popover/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Popper/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Portal/Portal.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Radio/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/RadioGroup/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Rating/Rating.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ScopedCssBaseline/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Select/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Skeleton/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Slide/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Slider/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Snackbar/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/SnackbarContent/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/SpeedDial/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/SpeedDialAction/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/SpeedDialIcon/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Step/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/StepButton/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/StepConnector/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/StepContent/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/StepIcon/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/StepLabel/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Stepper/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/styles/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/SvgIcon/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/SwipeableDrawer/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Switch/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Tab/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Table/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableBody/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableCell/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableContainer/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableFooter/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableHead/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TablePagination/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableRow/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TableSortLabel/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Tabs/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TabScrollButton/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TextareaAutosize/TextareaAutosize.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/TextField/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ToggleButton/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/ToggleButtonGroup/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Toolbar/Toolbar.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Tooltip/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Unstable_Grid2/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Unstable_TrapFocus/FocusTrap.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/useAutocomplete/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/usePagination/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/useScrollTrigger/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/utils/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/material/Zoom/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useControlled/useControlled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useForkRef/useForkRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useId/useId.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useIsFocusVisible/useIsFocusVisible.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useLazyRef/useLazyRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useOnMount/useOnMount.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/usePreviousProps/usePreviousProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useSlotProps/useSlotProps.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/@mui/utils/esm/useTimeout/useTimeout.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/node_modules/next/dist/client/image-component.js");
